"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
class RefStore {
    constructor() {
        this._stored = [];
        console.log("++++ RefStore constructor");
    }
    insert(key, ref) {
        const i = this.stored.findIndex(j => j.key === key);
        if (i < 0) {
            this.stored.push({ ref, key });
        }
        else {
            this.stored[i] = { ref, key };
        }
    }
    remove(key) {
        const i = this.stored.findIndex(j => j.key === key);
        if (i >= 0) {
            this.stored.splice(i, 1);
        }
    }
    get(key) {
        const i = this.stored.findIndex(j => j.key === key);
        if (i >= 0)
            return this._stored[i].ref;
        return null;
    }
    current(key) {
        const ref = this.get(key);
        if (ref)
            return ref.current;
        return null;
    }
    get stored() { return this._stored; }
}
exports.RefStore = RefStore;
// ------------------------------------------------------------
// React Context and Hook integration
exports.RefStoreContext = react_1.createContext(new RefStore());
// Use this to record React ref associated with an object (e.g. a Widget).
// It gets passed via a React Context to children widget.
//
function useNewRefStore() {
    const [refStore] = react_1.useState(new RefStore());
    return refStore;
}
exports.useNewRefStore = useNewRefStore;
// Can pass `null` as the key, in which case the ref will not be stored.
function useRefStore(key, _refStore = null) {
    // Use the RefStore given or the one in the Context if not given
    const refStoreContext = react_1.useContext(exports.RefStoreContext);
    const refStore = _refStore || refStoreContext;
    const ref = react_1.useRef();
    react_1.useEffect(() => {
        if (key) {
            refStore.insert(key, ref);
            return () => refStore.remove(key);
        }
    });
    return ref;
}
exports.useRefStore = useRefStore;
// Can pass `null` as the key, in which case the ref will not be stored.
function useRefStores(keys, _refStore = null) {
    // Use the RefStore given or the one in the Context if not given
    const refStoreContext = react_1.useContext(exports.RefStoreContext);
    const refStore = _refStore || refStoreContext;
    const refs = keys.map(k => [k, react_1.createRef()]);
    react_1.useEffect(() => {
        refs.forEach(([key, ref]) => {
            if (key && ref) {
                refStore.insert(key, ref);
                return () => refStore.remove(key);
            }
        });
    });
    return new Map(refs);
}
exports.useRefStores = useRefStores;
